
























































import { Component, Model, Prop, Vue } from "vue-property-decorator"
type File = {
    name: string
    url: string
    uid: string
    status: string
    view_url: string
    show_name: string
}
interface StandardFile {
    uid: string
    name: string
    status: "uploading" | "done" | "error" | "removed"
    // ...其他属性
}
@Component({
    name: "UploadFile",
    components: {}
})
export default class UploadFile extends Vue {
    @Model("change")
    fileList: any[]
    @Prop({ type: String, default: "添加" })
    descText: string
    @Prop({ type: String, default: "attachment_id" })
    uniqueKey: string
    @Prop({ type: String, default: "show_name" })
    label: string
    @Prop({ type: String, default: "attachment_id" })
    filterKey: string
    @Prop({ type: Boolean, default: false })
    multiple: boolean
    @Prop({ type: Boolean, default: false })
    disabled: boolean
    @Prop({ type: Boolean, default: false })
    uniqueFileName: boolean
    @Prop({ type: String, default: "*" })
    accept: string
    @Prop({ type: Number, default: 250 })
    maxFileSize: number
    @Prop({ type: Function, default: () => Promise.resolve() })
    beforeUpload: Function
    @Prop({ type: Boolean, default: true })
    canPreview: boolean
    @Prop({ type: Number, default: 0 })
    maxCount: number
    @Prop({ type: Function, default: () => Promise.resolve() })
    customUpload: (file: any) => Promise<any>
    async customUpload_(options: any) {
        if (this.maxCount) {
            if (this.fileList.length >= this.maxCount) {
                this.$message.warning(`最大上传数量为${this.maxCount}`)
                return
            }
        }
        // 重名校验
        if (this.uniqueFileName) {
            if (this.fileList.find(e => e.name === options.file.name)) {
                this.$message.warning(`${options.file.name} 的文件不能重复上传`)
                return
            }
        }
        const newFlie = {
            status: "uploading",
            name: options.file.name,
            uid: options.file.uid,
            url: URL.createObjectURL(options.file)
        }

        // size限制
        const isLtFileSize = options.file.size / 1024 / 1024 < this.maxFileSize
        if (!isLtFileSize) {
            this.$message.error(`文件大小不能超过${this.maxFileSize}M`)
            return
        }

        this.fileList.push(newFlie)
        await this.customUpload(options)
            .then(res => {
                newFlie.status = "done"
                if (res.url) {
                    newFlie.url = res.url
                    Object.assign(newFlie, res)
                }
                this.$message.success(`${newFlie.name}上传成功`)
            })
            .catch(err => {
                newFlie.status = "failed"
                console.error(err)
                this.$emit("failed", true)
                this.$message.error(err || "上传文件失败")
            })
            .finally(() => {
                if (this.maxCount) {
                    this.fileList = this.fileList.slice(-this.maxCount)
                }
                const fileList = this.fileList.filter(f => f.status !== "failed")
                this.$emit("change", fileList)
            })
    }
    private generateUID(): string {
        return `file-${Date.now()}-${Math.floor(Math.random() * 1000)}`
    }
    get standardFileList(): StandardFile[] {
        return this.fileList.map(file => ({
            ...file,
            uid: file.uid || file[this.uniqueKey] || this.generateUID(),
            name: file.name || file.show_name || "unknown",
            status: file.status || "done"
        }))
    }
    get iconUploadSuccess() {
        return require("./assets/icon-success.png")
    }
    get filePreviewImgUrlGetter() {
        return (file: File) => {
            const { show_name, view_url } = file
            const extName = show_name ? show_name.substring(show_name.lastIndexOf(".") + 1) : ""
            if (/doc|docx/i.test(extName)) {
                return require("./assets/icon-doc.png")
            } else if (/html/i.test(show_name)) {
                return require("./assets/icon-link.png")
            } else if (/ofd/i.test(show_name)) {
                return require("./assets/icon-ofd.png")
            } else if (/pdf/i.test(extName)) {
                return require("./assets/icon-pdf.png")
            } else if (/ppt/i.test(extName)) {
                return require("./assets/icon-ppt.png")
            } else if (/zip|rar/i.test(extName)) {
                return require("./assets/icon-rar.png")
            } else if (/xls/i.test(extName)) {
                return require("./assets/icon-xls.png")
            } else if (/txt/i.test(extName)) {
                return require("./assets/icon-txt.png")
            } else if (/png|jpg|gif|svg|jpeg/i.test(extName)) {
                return view_url
            } else {
                return require("./assets/icon-unknown.png")
            }
        }
    }
    get imageSources() {
        return this.fileList
            .filter((item: any) => {
                const { show_name } = item
                const extName = show_name ? show_name.substring(show_name.lastIndexOf(".") + 1) : ""
                return /png|jpg|gif|svg|jpeg/i.test(extName)
            })
            .map(item => item.view_url)
    }
    get uploadFileList() {
        return this.fileList.map(item => {
            return {
                ...item,
                status: "done",
                name: item.show_name,
                uid: item.uid || item.attachment_id
            }
        })
    }
    fileClick(file: any) {
        const { show_name, view_url } = file
        const extName = show_name ? show_name.substring(show_name.lastIndexOf(".") + 1) : ""
        if (/png|jpg|gif|svg|jpeg/i.test(extName)) {
            const index = this.imageSources.findIndex(cell => {
                return cell === view_url
            })
            this.$viewerApi({
                images: this.imageSources,
                options: {
                    initialViewIndex: index
                }
            })
        } else if (/pdf/i.test(extName)) {
            window.open(view_url)
        } else {
            this.$message.warning("文件暂不支持预览")
        }
    }

    // 是否支持预览
    supportPreview(file: any): boolean {
        const { show_name } = file
        const extName = show_name ? show_name.substring(show_name.lastIndexOf(".") + 1) : ""
        return /png|jpg|gif|svg|jpeg|pdf/i.test(extName)
    }

    // 拆分 文件名/扩展名
    fileInfoGettter(fullName = ""): string[] {
        const dotIdx = fullName.lastIndexOf(".")
        if (dotIdx !== -1) {
            return [fullName.slice(0, dotIdx + 1) || "未知文件", fullName.slice(dotIdx + 1)]
        } else {
            return [fullName || "未知文件", ""]
        }
    }

    removeFile(file: any) {
        if (this.disabled) {
            return
        }
        const ret = this.fileList.filter((item: any) => {
            return item[this.filterKey] !== file[this.filterKey]
        })
        this.$emit("change", ret)
    }
}
